import * as React from "react";

import { jsPDF } from "jspdf";

import _ from "lodash";

import "ol/ol.css";
import Overlay from "ol/Overlay";
import { Map } from "ol";
import { ScaleLine } from "ol/control";

import "./ShowPrint.scss";
import { Modal } from "./Modal";
import { EmbeddedMap } from "../embeddedmap";

const ORIENTATION_OPTIONS = ["landscape", "portrait"];
const RESOLUTION_OPTIONS = [72, 150, 300];
const DIMENSION_OPTIONS = {
  a0: [1189, 841],
  a1: [841, 594],
  a2: [594, 420],
  a3: [420, 297],
  a4: [297, 210],
  a5: [210, 148],
};

// base64 -w 0 north_arrow.png > north_arrow_png.b64
const NORTH_ARROW_PNG = "data:image/pgn;base64,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";

const writeScaleToCanvas = (_e: any /* RenderEvent*/, canvas: HTMLCanvasElement, scale?: ScaleLine): void => {
  if (scale === undefined) {
    return;
  }
  // Taken from https://www.kreidefossilien.de/webgis/dokumentation/beispiele/export-map-to-png-with-scale
  // It takes the first canvas during postcompose and extacts the css dimensions fromthe scale
  // Get the Scaleline div container the style-width property
  let selector = ".ol-scale-line-inner";
  let multiplier = 2; // how big should the scale be (original css-width multiplied)
  if ((scale as any).scaleBar_) {
    selector = ".ol-scale-bar-inner"
    multiplier = 1;
  }
  const olscale = document.querySelector(selector) as HTMLElement;
  const line = 6; //Scaleline thicknes
  let xOffset = 10; //Offset from the left
  const yOffset = 30; //Offset from the bottom
  const fontSize = 15;
  const fullFontName = fontSize + "px Arial";
  const white = "#ffffff";
  const black = "#000000";

  const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
  const scaleWidth = parseInt(olscale.style.getPropertyValue("width"), 10) * multiplier;
  const scaleText = olscale.innerText as string;
  const parts = scaleText.split("\n")
  xOffset = canvas.width - xOffset - scaleWidth;

  // Scale Text
  ctx.beginPath();
  ctx.textAlign = "left";
  ctx.strokeStyle = white;
  ctx.fillStyle = black;
  ctx.lineWidth = 5;
  ctx.font = fullFontName;

  // Scale Dimensions
  // @TODO: this should be in sync with this.props.embeddedMap.scale.scaleBarSteps
  //        but the text would be wrong, and the 4 black/white bars also....
  const spacers = 4
  const delta = scaleWidth / spacers;
  const xZero = scaleWidth + xOffset;
  const yZero = canvas.height - yOffset;
  const xFirst = xOffset + delta;
  const xSecond = xFirst + delta;
  const xThird = xSecond + delta;
  const xFourth = xThird + delta;

  ctx.fillText(parts[0], xSecond - 2 * fontSize, canvas.height - yOffset - fontSize - 2);
  ctx.fillText( parts[1], xFirst - delta, canvas.height - yOffset + fontSize + 2);
  ctx.fillText( parts[2], xSecond - fontSize, canvas.height - yOffset + fontSize + 2);
  ctx.fillText( parts[3], xFourth - 3 * fontSize, canvas.height - yOffset + fontSize + 2);

  // Stroke outline
  ctx.beginPath();
  ctx.lineWidth = line + 2;
  ctx.strokeStyle = black;
  ctx.fillStyle = white;
  ctx.moveTo(xOffset - 1, yZero);
  ctx.lineTo(xZero + 1, yZero);
  ctx.stroke();

  //sections black/white
  ctx.beginPath();
  ctx.lineWidth = line;
  ctx.strokeStyle = white;
  ctx.moveTo(xOffset, yZero);
  ctx.lineTo(xFirst, yZero);
  ctx.stroke();

  ctx.beginPath();
  ctx.lineWidth = line;
  ctx.strokeStyle = black;
  ctx.moveTo(xFirst, yZero);
  ctx.lineTo(xSecond, yZero);
  ctx.stroke();

  ctx.beginPath();
  ctx.lineWidth = line;
  ctx.strokeStyle = white;
  ctx.moveTo(xSecond, yZero);
  ctx.lineTo(xThird, yZero);
  ctx.stroke();

  ctx.beginPath();
  ctx.lineWidth = line;
  ctx.strokeStyle = black;
  ctx.moveTo(xThird, yZero);
  ctx.lineTo(xFourth, yZero);
  ctx.stroke();
};

export const convertMapToImage = function (
  map: Map,
  printSize: [number, number],
  orgSize: [number, number],
  viewResolution: number,
  postProcess: (
    mapCanvas: HTMLCanvasElement,
    orgSize: [number, number],
    viewResolution: number
  ) => void,
  scale?: ScaleLine,
): void {
  map.once("rendercomplete", function (evt) {
    const mapCanvas = document.createElement("canvas");
    mapCanvas.width = printSize[0];
    mapCanvas.height = printSize[1];
    const mapContext = mapCanvas.getContext("2d") as CanvasRenderingContext2D;
    Array.prototype.forEach.call(
      document.querySelectorAll(".ol-layer canvas"),
      function (canvas) {
        if (canvas.width > 0) {
          const opacity = canvas.parentNode.style.opacity;
          mapContext.globalAlpha = opacity === "" ? 1 : Number(opacity);
          const transform = canvas.style.transform;
          // Get the transform parameters from the style's transform matrix
          const matrix = transform
            .match(/^matrix\(([^(]*)\)$/)[1]
            .split(",")
            .map(Number);
          // Apply the transform to the export map context
          CanvasRenderingContext2D.prototype.setTransform.apply(
            mapContext,
            matrix
          );
          mapContext.drawImage(canvas, 0, 0);
        }
      }
    );
    try {
      writeScaleToCanvas(evt, mapCanvas, scale);
      postProcess(mapCanvas, orgSize, viewResolution);
    } catch (err) {
      if (err.message === "The operation is insecure.") {
        if (
          window.location.protocol === "http:" &&
          window.location.hostname === "localhost"
        ) {
          alert("Hint: add CORS to map, or run from https instead http");
        }
      }
    }
  });
};

export const resetMap = function (
  map: Map,
  orgSize: [number, number],
  viewResolution: number
): void {
  map.setSize(orgSize);
  map.getView().setResolution(viewResolution);
};

interface ShowPrintProps {
  map: Map;
  embeddedMap: EmbeddedMap;
  overlay: Overlay;
}

interface ShowPrintState {
  title: string;
  orientation: typeof ORIENTATION_OPTIONS[number];
  resolution: typeof RESOLUTION_OPTIONS[number];
  format: "a0" | "a1" | "a2" | "a3" | "a4" | "a5"; //todo keyof DIMENSION_OPTIONS;
}

export class ShowPrint extends React.Component<ShowPrintProps, ShowPrintState> {
  constructor(props: ShowPrintProps) {
    super(props);
    this.state = {
      title: "GrexManager print",
      orientation: ORIENTATION_OPTIONS[0],
      resolution: RESOLUTION_OPTIONS[0],
      format: "a4",
    };
    this.changeFieldCb = this.changeFieldCb.bind(this);
    this.printButtonCb = this.printButtonCb.bind(this);
    // @TODO: for some reason, the opening of this modal is very slow.
    //        what is react doing here? Reticulating splines ?
  }

  changeFieldCb(
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ): void {
    const key = event?.target?.name;
    const value = event?.target?.value;
    if (
      ["title", "scale", "orientation", "resolution", "format"].indexOf(key) !==
      -1
    ) {
      this.setState((oldState) => {
        return Object.assign(oldState, { [key]: value });
      });
    }
  }

  private printButtonCb(event: React.MouseEvent<HTMLButtonElement>): void {
    //https://openlayers.org/en/latest/examples/export-pdf.html
    const exportButton = event?.target as HTMLButtonElement;
    exportButton.disabled = true;
    document.body.style.cursor = "progress";

    const title = this.state.title;
    const format = this.state.format;
    const orientation = this.state.orientation as "landscape" | "portrait"; //todo improve type
    const resolution = this.state.resolution;
    const dim = DIMENSION_OPTIONS[format];
    const width = Math.round((dim[0] * resolution) / 25.4);
    const height = Math.round((dim[1] * resolution) / 25.4);
    const rad = this.props.map.getView()?.getRotation(); // anti clockwise ?

    const postProcess = function (
      mapCanvas: HTMLCanvasElement,
      orgSize: [number, number],
      viewResolution: number
    ) {
      const pdf = new jsPDF(orientation, undefined, format);
      // A JPG layer without OSM background turns out to be black, so we use png
      const dataURL = mapCanvas.toDataURL("image/png");
      pdf.addImage(
        dataURL,
        "PNG",
        0,
        0,
        dim[0],
        dim[1]
      );
      pdf.addImage(NORTH_ARROW_PNG, 'PNG', 15, 15, 0, 0, undefined, undefined, 360 - rad * 180 / Math.PI);
      const now = new Date();
      const filename = `${title}_${now.toLocaleString("NL-nl")}.pdf`;
      pdf.save(filename.replace(/ /g, "_"));
      resetMap(map, orgSize, viewResolution);
      exportButton.disabled = false;
      document.body.style.cursor = "auto";
    };

    const map = this.props.map;
    const size = map.getSize() as [number, number];
    const viewResolution = map.getView().getResolution() as number;
    convertMapToImage(
      map,
      [width, height],
      size,
      viewResolution,
      postProcess,
      this.props.embeddedMap.scale
    );
    // Set print size
    map.setSize([width, height]);
    const scaling = Math.min(width / width, height / height);
    map.getView().setResolution(viewResolution / scaling);
    document.getElementById("popup-closer")?.click();
  }

  render(): JSX.Element {
    // @TODO translations
    const trShowPrint = "PDF afdruk";
    const trTitle = "Titel kaart";
    const trOrientation = "Oriëntatie";
    const trResolution = "Resolutie";
    const trFormat = "Papier formaat";

    const trPortrait = "Staand";
    const trLandscape = "Liggend";
    const trPrint = "Afdrukken";
    const trDefaultTitle = "Project overzicht";

    const trScaleOptions = {
      [ORIENTATION_OPTIONS[0]]: trLandscape,
      [ORIENTATION_OPTIONS[1]]: trPortrait,
    };

    const Content = () => {
      return (
        <div>
          <table className={"tablestyle"}>
            <tbody>
              <tr>
                <td>
                  <label
                  htmlFor={"title"}
                  className={"labelstyles"}
                  >{trTitle}
                  </label>
                </td>
                <td>
                  <input
                    name={"title"}
                    id={"title"}
                    className={"form-control"}
                    placeholder={trDefaultTitle}
                    value={this.state.title}
                    onChange={this.changeFieldCb}
                  />
                </td>
              </tr>

              <tr>
                <td>
                  <label
                  htmlFor={"orientation"}
                  className={"labelstyles"}
                  >
                  {trOrientation}</label>
                </td>
                <td>
                  <select
                    id={"orientation"}
                    name={"orientation"}
                    className={"form-control"}
                    defaultValue={this.state.orientation}
                    onChange={this.changeFieldCb}
                  >
                    {_.map(trScaleOptions, (option, key) => {
                      return (
                        <option key={key} value={key}>
                          {option}
                        </option>
                      );
                    })}
                  </select>
                </td>
              </tr>
              <tr>
                <td>
                  <label
                  htmlFor={"resolution"}
                  className={"labelstyles"}
                  >{trResolution}
                  </label>
                </td>
                <td>
                  <select
                    id={"resolution"}
                    name={"resolution"}
                    className={"form-control"}
                    defaultValue={this.state.resolution}
                    onChange={this.changeFieldCb}
                  >
                    {_.map(RESOLUTION_OPTIONS, (option, key) => {
                      return (
                        <option key={key} value={option}>
                          {option} {"DPI"}
                        </option>
                      );
                    })}
                  </select>
                </td>
              </tr>

              <tr>
                <td>
                  <label
                  htmlFor={"format"}
                  className={"labelstyles"}
                  >{trFormat}</label>
                </td>
                <td>
                  <select
                    id={"format"}
                    name={"format"}
                    className={"form-control"}
                    defaultValue={this.state.format}
                    onChange={this.changeFieldCb}
                  >
                    {_.map(DIMENSION_OPTIONS, (option, key) => {
                      return (
                        <option key={key} value={key}>
                          {key}
                        </option>
                      );
                    })}
                  </select>
                </td>
              </tr>
              <tr>
                <td colSpan={2} style={{textAlign: "right"}}>
                  <button className={"btn btn-primary"} onClick={this.printButtonCb}>{trPrint}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    };
    return (
      <Modal
        className={"showlayerinfo__contents"}
        title={trShowPrint}
        content={Content()}
        modal={this}
      />
    );
  }
}
